// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-519efaed]{position:relative;z-index:11;display:flex;align-items:center;color:#51596c}button.type-list[data-v-519efaed]{flex-direction:column;font-size:14px}button.type-list .text[data-v-519efaed]{opacity:0;transition:opacity .3s;height:0}button.type-list.is-saved .text[data-v-519efaed]{opacity:1}button.type-detail[data-v-519efaed]{font-size:16px}button.type-detail .text[data-v-519efaed]{padding-right:.625rem}button img[data-v-519efaed]{height:32px}", ""]);
// Exports
module.exports = exports;
